import { render } from "./Orchestras.vue?vue&type=template&id=687a1051"
import script from "./Orchestras.vue?vue&type=script&lang=js"
export * from "./Orchestras.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__